import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Components
import DataTable from "react-data-table-component";
import Layout from "../../../../Layout/Layout";
// import SourcingCommonFilter from "../../../../Components/Filter/Sourcing/SourcingCommonFilter";
import Constants from "../../../../common/SupplierConstants";
import OrderSchedulingModal from "./OrderSchedulingModal";
import {
  getOrderSchedulingList,
  orderNr,
} from "../../../../redux/feature/customer_app/customerV1Slice";
import { SearchField } from "../../../../Components/formElements/SearchField";
// import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import {
  /*  formatDate, */
  /*   formatDateTime, */
  formatDateWithAMPM,
  formatNumber,
} from "../../../../common/Validations";
import OrderCancelModal from "./OrderCancelModal";
import OrderCarryForwardModal from "./OrderCarryForwardModal";
import LoadingAdviceOrderHistoryModal from "./LoadingAdviceOrderHistoryModal";
import CreditPolicyRequestFormOrderBookingModal from "../CreditPolicy/CreditPolicyRequestFormOrderBookingModal";
import CommonFilterCustomerV2 from "../Common/CommonFilterCustomerV2";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import CustomerConstants from "../../../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import FlowStatusHistory from "../../../../Components/FlowStatusHistory/flowStatusHistory";
const OrderBookingList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "Customer");
  localStorage.setItem("submenu", "Order Booking");

  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  let orderSchedulingData = useSelector(
    (state) => state?.customerV1?.order_scheduling,
  ); // User Details from Store
  let orderSchedulingTable = useSelector(
    (state) => state?.customerV1?.order_scheduling.pagination,
  ); // User Details from Store

  const [isCardVisible1, setCardVisible1] = useState(true);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  // const detailedPage = (number) => {};

  const [data, setData] = useState();
  // console.log(">>data",data)
  const [getOrderCancelModal, setOrderCancelModal] = useState(false);
  // const [getCancelSelectedData, setCancelSelectedData] = useState(null); // Store selected data

  const [getOrderCarryFrdModal, setOrderCarryFrdModal] = useState(false);
  const [getCarryFrdSelectedData, setCarryFrdSelectedData] = useState(null); // Store selected data

  // const [getModalLoadingAdvice, setModalLoadingAdvice] = useState(false);
  // eslint-disable-next-line
  const [loadingAdviceData, setLoadingAdviceData] = useState(null);
  const [getModalLoadingAdviceHistory, setModalLoadingAdviceHistory] =
    useState(false);
  // eslint-disable-next-line
  const [historyStatus, setHistoryStatus] = useState(false);

  const [filterShow, setFilterShow] = useState(false);

  const [getFilter, setFilter] = useState({});

  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");
  const showStatusInfo = (rowData) => {
    setModalShowStatus(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };
  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const detailedPage = (orderID) => {
    dispatch(orderNr(orderID));
    navigate(CustomerConstants.CUSTOMER_V2_ORDER_BOOKING_UPDATE);
  };

  //show histroy modal
  const showLoadingAdviceHistory = (data) => {
    setModalLoadingAdviceHistory(true);
    setLoadingAdviceData(data);
    setHistoryStatus(true);
  };

  const userListColInfo = [
    {
      name: "Order Nr",
      id: "documentNumber",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPage(row.documentNumber)}
        >
          {row.documentNumber || "-"}
        </button>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Ver",
      id: "version",
      selector: (row) => row.version,
      cell: (row) => (
        <>
          <span className="fw-bold text-success">{row.version}</span>
        </>
      ),
      sortable: true,
      width: "70px",
    },
    {
      name: "Created Date",
      id: "createdAt",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">
            {/* {formatDateTime(row.createdAt)} */}
            {/* {formatDateTime(row.updatedAt)} */}
            {formatDateWithAMPM(row.updatedAt)}
          </span>
        </>
      ),
      sortable: true,
      width: "130px",
    },
    // {
    //   name: "Status / Priority",
    //   selector: (row) =>
    //     `${row.salesOrderStatus || ""} ${row.items?.priority || ""}`,
    //   cell: (row) => (
    //     <div className="d-flex flex-column gap-1">
    //       <TableStatusField status={row.salesOrderStatus} />
    //       <TableStatusField status={row.items?.priority} />
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "200px",
    // },
    {
      name: "Status / Priority",
      id: "salesOrderStatus",
      selector: (row) =>
        `${row.salesOrderStatus || ""} ${row.items?.priority || ""}`,
      cell: (row) => (
        <div className="d-flex flex-column gap-1">
          <p
            className={`m-0 p-0 fw-bold ${
              row?.salesOrderStatus === "Created"
                ? "text-primary"
                : row?.salesOrderStatus === "Fully Loaded"
                  ? "text-success"
                  : "text-muted" || row?.salesOrderStatus === "Partially Loaded"
                    ? "text-danger"
                    : "text-muted"
            }`}
          >
            {row?.salesOrderStatus || "-"}
          </p>
          {/* <span className="text-success">{row.items?.priority || "-"}</span>
           */}
          <TableStatusField status={row.items?.priority} />
        </div>
      ),
      sortable: true,
      width: "180px",
      wrap: true,
    },
    {
      name: "Workflow log",
      selector: (row) => row.flowStatusHistory?.length || 0,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center iconTable"
        >
          <img
            src="assets/img/newIcons/workflow.png"
            alt="Workflow log"
            title="View workflow history"
            style={{
              width: "35px",
              cursor: "pointer",
            }}
            className="mt-1"
            onClick={() => showStatusInfo(row.flowStatusHistory || [])}
          />
        </div>
      ),
      sortable: false,
      width: "132px",
    },
    // {
    //   name: "Status",
    //   id: "salesOrderStatus",
    //   selector: (row) => row.salesOrderStatus,
    //   cell: (row) => (
    //     <>
    //       <span className="bg-table-status bg-table-new-status">
    //         {row.salesOrderStatus}
    //       </span>
    //     </>
    //   ),
    //   sortable: true,
    //   width: "200px",
    // },
    // {
    //   name: "Priority",
    //   selector: (row) => row?.items?.priority,
    //   cell: (row) => (
    //     <>
    //       <TableStatusField status={row.items?.priority} />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "200px",
    // },

    // {
    //   name: "Company",
    //   id: "companyCodeDesc",
    //   selector: (row) => row.companyCode,
    //   cell: (row) => (
    //     <>
    //       <span className="fw-bold text-success">{row.companyCodeDesc}</span>
    //     </>
    //   ),
    //   sortable: true,
    //   width: "140px",
    // },

    {
      name: "Customer",
      id: "customerName",
      selector: (row) => row.sapDocumentNumber,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1 fw-bold ">{row.customerName} </p>
            <p className="m-0 p-0 ">{row.sapDocumentNumber} </p>
            <p className="m-0 p-0 fw-bold text-success">
              {row.companyCodeDesc}{" "}
            </p>
          </div>
        </>
      ),
      sortable: true,
      width: "220px",
    },
    // {
    //   name: "Shipping Address",
    //   selector: (row) => row?.items?.[0]?.shippingAddress || "",
    //   cell: (row) => {
    //     const item = row?.items?.[0];

    //     return (
    //       <div className="py-1">
    //         <p className="m-0 fw-bold">{item?.shippingAddress || "-"}</p>
    //         <p className="m-0 text-muted">{item?.shippingPostalCode || ""}</p>
    //       </div>
    //     );
    //   },
    //   sortable: true,
    //   width: "250px",
    //   wrap: true,
    // },

    {
      name: "Shipping Address",
      selector: (row) => row?.items?.shippingAddress || "",
      cell: (row) => {
        const item = row?.items;

        return (
          <div className="py-1">
            <p className="m-0 fw-bold">{item?.shippingAddress || "-"}</p>
            <p className="m-0 text-success fw-bold">
              PIN: {item?.shippingPostalCode || "-"}
            </p>
          </div>
        );
      },
      sortable: true,
      width: "250px",
      wrap: true,
    },
    {
      name: "Item Nr",
      selector: (row) => row.sapDocumentNumber,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1 fw-bold ">{row?.items?.local_id} </p>
            {/* <p className="m-0 p-0 ">{row.sapDocumentNumber} </p> */}
          </div>
        </>
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "Material",
      selector: (row) => row?.items?.materialCode,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0  fw-bold">
              {row?.items?.materialDescription}{" "}
            </p>
            <p className="m-0 p-0 pt-1  ">{row?.items?.materialCode} </p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Qty & Price",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold text-primary">
            ₹ {formatNumber(row?.items?.unitPrice ?? 0, "comma")}
          </p>

          <p className="m-0 p-0 fw-medium">
            {row?.items?.orderQuantityLoad ?? "--"} {row?.items?.uOM || ""}
          </p>
            <p className="m-0 p-0 pt-1 fw-bold text-primary">
            ₹ {formatNumber(row?.items?.netValue ?? 0, "comma")}
          </p>

         
        </div>
      ),
      selector: (row) => row?.items?.unitPrice ?? 0,
      sortable: true,
      width: "140px",
    },
    {
      name: "Bal Qty",
      selector: (row) => row?.items?.balanceQty,
      cell: (row) => (
        <>
          <span className="fw-bold text-danger">{row?.items?.balanceQty}</span>
        </>
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "EX/FOR",
      selector: (row) =>
        row?.items?.exWork === "Ex-Work"
          ? row?.items?.loadingTruckNo || ""
          : row?.items?.exWork || "",
      cell: (row) => (
        <span className="fw-bold">
          {row?.items?.exWork === "Ex-Work"
            ? row?.items?.loadingTruckNo || "--"
            : row?.items?.exWork || "--"}
        </span>
      ),
      sortable: true,
      width: "150px",
    },

    {
      name: "Loading Advice",
      selector: (row) => row.updateLoadingStatus,
      cell: (row) => (
        <>
          {row.updateLoadingStatus ? (
            <div
              style={{ marginLeft: "30px", fontSize: "30px" }}
              onClick={() => showLoadingAdviceHistory(row)}
              className="iconTableNew"
            >
              <img
                src="assets/img/newIcons/delivery-truck.png"
                alt="attachments"
                style={{ width: "40px" }}
                className="mt-1"
              />
            </div>
          ) : (
            ""
          )}
        </>
      ),
      sortable: true,
      width: "150px",
    },

    // {
    //   name: "Customer",
    //   selector: (row) => row.customerDetails,
    //   cell: (row) => (
    //     <>
    //       <span >{row.customerDetails}</span>
    //     </>
    //   ),
    //   sortable: true,
    //   width: "120px",
    // },
    // {
    //   name: "Other Cust",
    //   selector: (row) => row.customerDetailsIfOther,
    //   cell: (row) => (
    //     <>
    //       <span>{row.customerDetailsIfOther}</span>
    //     </>
    //   ),
    //   sortable: true,
    //   width: "120px",
    // },
    // {
    //   name: "Delivery",
    //   selector: (row) => row.deliveryAddress,
    //   cell: (row) => (
    //     <>
    //       <span >{row.deliveryAddress}</span>
    //     </>
    //   ),
    //   sortable: true,
    //   width: "120px",
    // },
    // {
    //   name: "Remarks",
    //   selector: (row) => row.deliveryAddress,
    //   cell: (row) => (
    //     <>
    //       <span >{row.deliveryAddress}</span>
    //     </>
    //   ),
    //   sortable: true,
    //   width: "120px",
    // },
    // {
    //   name: "CanlQty(H)",
    //   cell: (row) => (
    //     <>
    //       <span
    //         style={{ marginLeft: "12px" }}
    //         // onClick={() => showCancelQtyList(row.cancelHostory)}
    //       >
    //         <i className="bi bi-calendar2-week iconTable"></i>
    //       </span>
    //       <span className="suppliersIcon">
    //         {" "}
    //         {row.cancelHostory?.length || 0}{" "}
    //       </span>
    //     </>
    //   ),
    //   width: "120px",
    // },
    // {
    //   name: "CarryFrd(H)",
    //   cell: (row) => (
    //     <>
    //       <span
    //         style={{ marginLeft: "12px" }}
    //         /*  onClick={() => showCarryForwardList(row.carryForwardHostory)} */
    //       >
    //         <i className="bi bi-calendar2-week iconTable"></i>
    //       </span>
    //       <span className="suppliersIcon">
    //         {" "}
    //         {row.carryForwardHostory?.length || 0}{" "}
    //       </span>
    //     </>
    //   ),
    //   width: "120px",
    // },

    {
      name: "A/C",
      selector: (row) => row.items?.accOnOff,
      sortable: true,
      width: "120px",
      cell: (row) => {
        const isOn = row?.items?.accOnOff;

        return (
          <div className="flex justify-center">
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={isOn}
                disabled={true}
              />

              {/* Switch background */}
              <div
                className={`w-11 h-6 rounded-full transition-colors duration-300
              ${isOn ? "bg-green-500" : "bg-red-500"}
            `}
              ></div>

              {/* Circle */}
              <div
                className={`absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform duration-300
              ${isOn ? "translate-x-5" : "translate-x-0"}
            `}
              ></div>
            </label>
          </div>
        );
      },
    },
    {
      name: "Dispatch Date",
      selector: (row) => row?.items?.dispatchDate || "",
      cell: (row) => {
        const date = row?.items?.dispatchDate;

        return (
          <div className="py-1">
            {date
              ? new Date(date + "T00:00:00").toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })
              : "-"}
          </div>
        );
      },
      sortable: true,
      width: "150px",
    },
    {
      name: "Dispatch Remarks",
      selector: (row) => row?.items?.dispatchRemarks || "",
      cell: (row) => (
        <div className="py-1">
          <p className="m-0">{row?.items?.dispatchRemarks || "-"}</p>
        </div>
      ),
      sortable: true,
      width: "200px",
      wrap: true,
    },
    {
      name: "Sales Officer",
      // id: "createdByName",
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1 fw-bold ">{row.salesOfficerName} </p>
            <p className="m-0 p-0 ">{row.salesOfficerCode} </p>
          </div>
        </>
      ),
      selector: (row) => row.createdByName || "--",
      sortable: true,
      width: "140px",
    },
    {
      name: "Customer Addr",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row?.items?.customerAddress} </p>
          <p className="m-0 p-0 pt-1">{row?.items?.customerPostalCode} </p>
        </div>
      ),
      sortable: true,
      width: "240px",
    },
    {
      name: "Created By",
      // id: "createdByName",
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1 fw-bold ">{row.createdByName} </p>
            <p className="m-0 p-0 ">{row.createdBy} </p>
          </div>
        </>
      ),
      selector: (row) => row.createdByName || "--",
      sortable: true,
      width: "140px",
    },
    {
      name: "Action",
      selector: (row) => row.dispatchDate,
      cell: (row) => (
        <>
          {row.balOrderQuantityLoad === 0 ? (
            <button className="btnTable btn-danger">Cancel</button>
          ) : (
            <button
              className="btnTable btn-danger"
              // onClick={() => showCancel(row)}
            >
              Cancel
            </button>
          )}
        </>
      ),
      sortable: true,
      width: "120px",
    },
  ];

  const [getOrderSheduling, setOrderSheduling] = useState(false);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [getUserRoleStatus, setUserRoleStatus] = useState(true);

  const orderBookingCreation = () => {
    navigate(CustomerConstants.CUSTOMER_V2_NEW_ORDER_BOOKING);
  };
  // eslint-disable-next-line
  const showOrderScheduling = () => {
    setOrderSheduling(true);
  };
  const hideOrderScheduling = () => {
    setOrderSheduling(false);

    let obj = {
      queryName: "getOrderScheduleBookingListV2",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
    };
    dispatch(getOrderSchedulingList(obj));
  };

  const loadInitialSuuplierData = async () => {
    setData(orderSchedulingData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {};
    const filterCheck = Object.keys(getFilter);
    if (filterCheck.length > 0) {
      obj = {
        queryName: "getOrderScheduleBookingListV2",
        module: "CUSTOMER",
        page: page,
        per_page: getNewPerPage,
        rowFilter: {
          $and: [getFilter],
        },
      };
    } else {
      obj = {
        queryName: "getOrderScheduleBookingListV2",
        module: "CUSTOMER",
        page: page,
        per_page: getNewPerPage,
      };
    }
    dispatch(getOrderSchedulingList(obj));
    setData(orderSchedulingData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {};
    const filterCheck = Object.keys(getFilter);
    if (filterCheck.length > 0) {
      obj = {
        queryName: "getOrderScheduleBookingListV2",
        module: "CUSTOMER",
        page: page,
        per_page: newPerPage,
        rowFilter: {
          $and: [getFilter],
        },
      };
    } else {
      obj = {
        queryName: "getOrderScheduleBookingListV2",
        module: "CUSTOMER",
        page: page,
        per_page: newPerPage,
      };
    }

    setNewPerPage(newPerPage);
    dispatch(getOrderSchedulingList(obj));
    setData(orderSchedulingData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getOrderScheduleBookingListV2",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getOrderSchedulingList(obj));
  };
  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {
      queryName: "getOrderScheduleBookingListV2",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: {
        $and: [filters],
      },
    };
    setFilter(filters);
    dispatch(getOrderSchedulingList(obj));
  };

  useEffect(() => {
    loadInitialSuuplierData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderSchedulingData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "getOrderScheduleBookingListV2",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
    };
    dispatch(getOrderSchedulingList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const userRole = userData?.roles?.[0]?.roleId || null;

    if (userRole === "CUSTOMER") {
      setUserRoleStatus(false);
    } else if (
      userRole === "SALES-COORDINATOR" ||
      userRole === "GENERAL-MNGR" ||
      userRole === "DISPATCH-OFFICER" ||
      userRole === "SALES-DIRECTOR"
    ) {
      setUserRoleStatus(false);
    } else {
      setUserRoleStatus(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  //cancel Modal
  // const showCancel = (item) => {
  //   setCancelSelectedData(item);
  //   setOrderCancelModal(true);
  // };
  const hideModal = () => {
    setOrderCancelModal(false);
    setModalLoadingAdviceHistory(false);
  };

  // showCarryFrd Modal
  // const showCarryFrd = (item) => {
  //   setCarryFrdSelectedData(item);
  //   setOrderCarryFrdModal(true);
  // };

  const hideshowCarryFrdModal = () => {
    setOrderCarryFrdModal(false);
    setCarryFrdSelectedData(null);
  };

  const [getCreditPolicyFormModal, setCreditPolicyFormModal] = useState(false);

  //CreditPolicyRequestFormModal
  // const showCreditPolicyRequestForm = () => {
  //   // setCreditPolicyFormData(items);
  //   setCreditPolicyFormModal(true);
  // };

  const hideCreditPolicyRequestForm = () => {
    setCreditPolicyFormModal(false);
  };

  //Common filter id
  // const extractFilterTemplate = () => {
  //   const filtered = userListColInfo.reduce((acc, col) => {
  //     if (col.id) {
  //       acc[col.id] = ""; // You can put null or a placeholder instead of ""
  //     }
  //     return acc;
  //   }, {});
  //   setFilterData(filtered);
  // };

  // // Call this once when you want to initialize the filter data
  // useEffect(() => {
  //   extractFilterTemplate();
  // }, []);

  // useEffect(() => {
  //   if (data && data.length > 0) {
  //     const firstRow = data[0]; // or any row you want
  //     const filtered = userListColInfo.reduce((acc, col) => {
  //       if (col.id) {
  //         acc[col.id] = firstRow[col.id] || ""; // pull actual value or fallback to ""
  //       }
  //       return acc;
  //     }, {});
  //     setFilterData(filtered);
  //   }
  // }, [data]);

  //sending data from data table which contain ids
  // const extractIds = () => {
  //   const filtered = userListColInfo
  //     .filter((col) => col.id)
  //     .map((col) => ({ id: col.id ,name: col.name}));
  //   setFilterData(filtered);
  // };

  // Call once when needed, e.g., on mount
  // useEffect(() => {
  //   extractIds();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // console.log(">>getFilterData", getFilterData);

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Order Booking</h2>
                <p className="subText">Order Booking List</p>
              </Col>
              <Col xs={8} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i className="bi bi-filter"></i>
                </span>
              </Col>
            </Row>

            <hr />
            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <CommonFilterCustomerV2
                    getfiltereddata={userListColInfo}
                    cancelAction={() => setFilterShow(!filterShow)}
                    onSubmit={(filters) => {
                      // console.log(">>Received filters from child:", filters);
                      // const filterData=[filters]
                      handleAdvanceSearchFuncApi(filters);
                      // You can now use the filters here
                    }}
                  />
                )}
              </Col>
            </Row>

            {/* user list */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">OD</span>
                    </Col>
                    <Col xs={9} md={7} lg={8}>
                      <span className="headerTitle">
                        Order Booking Details{" "}
                      </span>
                      <span className="subHeaderTitle">
                        View of Customer Orders List{" "}
                      </span>
                    </Col>
                    {getUserRoleStatus && (
                      <>
                        <Col
                          xs={4}
                          md={2}
                          lg={2}
                          className="d-flex justify-content-center"
                        >
                          <button
                            className="btnTable"
                            // onClick={() => showOrderScheduling()}
                            onClick={orderBookingCreation}
                          >
                            Customer Order Booking
                          </button>
                        </Col>
                        {/* <Col xs={4} md={2} lg={2} className="">
                          <button
                            className="btnTable"
                            onClick={() => showCreditPolicyRequestForm()}
                          >
                            Credit Policy Request
                          </button>
                        </Col> */}
                      </>
                    )}

                    {/* <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col> */}
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                       <StickyColumn
                        columnIndexes={[2, 3]}
                        leftOffsets={[0, 120, 300]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={userListColInfo}
                          data={data}
                          progressPending={orderSchedulingData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={orderSchedulingTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelect}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <OrderSchedulingModal
        show={getOrderSheduling}
        onHide={hideOrderScheduling}
        clear={true}
      />
      <OrderCancelModal
        show={getOrderCancelModal}
        onHide={() => hideModal(getOrderCancelModal)}
        // data={getCancelSelectedData}
        onSuccess={() => handleSearchFuncApi()}
      />
      <OrderCarryForwardModal
        show={getOrderCarryFrdModal}
        onHide={hideshowCarryFrdModal}
        data={getCarryFrdSelectedData}
        onSuccess={() => handleSearchFuncApi()}
      />
      <LoadingAdviceOrderHistoryModal
        show={getModalLoadingAdviceHistory}
        onHide={() => hideModal()}
        loadingadvicedata={loadingAdviceData}
        historyStatus={historyStatus}
        // onsuccessdata={handleSuccessData}
      />
      <CreditPolicyRequestFormOrderBookingModal
        show={getCreditPolicyFormModal}
        onHide={() => hideCreditPolicyRequestForm()}
        // data={getCreditPolicyFormData}
        // onSuccess={() => handleSearchFuncApi()}
      />
      <FlowStatusHistory
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
    </main>
  );
};

export default OrderBookingList;
